import cn from '@/lib/cs';
import React from 'react';

const InfoIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 22"
		className={cn(
			'h-8 lg:h-12 pointer-events-none overflow-visible',
			className
		)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				d="m12.2 23.9 6-1.4 4.5-4.4 1.3-6L22.7 6l-4.5-4.4-6-1.6-6.1 1.4L1.7 6 0 12l1.7 6.2 4.6 4.2 6 1.6M9.8 2.9l4.7.2-.1 3.2L13 8 10 7.7l-.2-4.6m5.6 18.6L9 21.5l-.5-.6-.3-2.7.8-.4.8-.2.5-.5.3-2.6-.8-.6-.8-.1-.4-.4-.2-2.7.6-.7 4.5.3.6.4.2 6.4.3.8.8-.2.5.5V21l-.5.8Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default InfoIcon;
